import DefaultLayout from './layout/default-layout/index'
import PageLayout from './layout/page-layout/index'
import ErrorPage from './views/system/error-page/index'
import UnderDevelopment from './views/system/under-development/index'

export {DefaultLayout, PageLayout, ErrorPage,UnderDevelopment}
/**
 * 系统页面
 */
import {ApiLog} from './views/system/api-log/index'

export {ApiLog}

import {AreaManage} from './views/system/area/index'

export {AreaManage}

import {UserManage, UserEdit, UserDetail, UserRole} from './views/system/user/index'

export {UserManage, UserEdit, UserDetail, UserRole}

import {UnitManage, UnitEdit, UnitDetail} from './views/system/unit/index'

export {UnitManage, UnitEdit, UnitDetail}

import {MenuManage, MenuEdit, MenuDetail, MenuBtn, MenuBtnEdit} from './views/system/menu/index'

export {MenuManage, MenuEdit, MenuDetail, MenuBtn, MenuBtnEdit}

import {RoleManage, RoleEdit, RoleUser, RoleMenu} from './views/system/role/index'

export {RoleManage, RoleEdit, RoleUser, RoleMenu}

import {QuartzManage, QuartzEdit} from './views/system/quartz/index'

export {QuartzManage, QuartzEdit}

import {CodeManage, SimpleCode, SimpleCodeEdit} from './views/system/code/index'

export {CodeManage, SimpleCode, SimpleCodeEdit}


import {ParamManage, ParamEdit} from './views/system/param/index'

export {ParamManage, ParamEdit}
/**
 * 组件
 */

import HeadLine from './components/layout/headline/index'
import LeafletTitle from './components/layout/title/leaflet/index'
import FixedFooter from './components/layout/fixed-footer/index'
const COMPONENT_LAYOUT = [HeadLine,LeafletTitle,FixedFooter]

import FilePreview from './components/data-display/preview/index'

const COMPONENT_DATA_DISPLAY = [FilePreview]

import DataImport from './components/data-input/data-import/index'
import FileUpload from './components/data-input/file-upload/index'
import AmountInput from './components/data-input/input/amout/index'
import CodeSelect from './components/data-input/select/code-select/index'
import CodeMultiple from './components/data-input/select/code-multiple/index'
import CustomMultiple from './components/data-input/select/custom-multiple/index'


const COMPONENT_DATA_INPUT = [DataImport, FileUpload,AmountInput, CodeSelect, CodeMultiple, CustomMultiple]

import BaseDialog from './components/feedback/base-dialog/index'
import StepDialog from './components/feedback/step-dialog/index'
const COMPONENT_FEEDBACK = [BaseDialog,StepDialog]

import BasePagination from './components/navigation/base-pagination/index'

import PageHeader from './components/navigation/page-header/PageHeader'

const COMPONENT_NAVIGATION = [BasePagination,  PageHeader]

import ZwxScrollbarX from './components/other/scrollbar/horizontal/index'
import ZwxScrollbarY from './components/other/scrollbar/vertical/index'
import SkinTheme from './components/other/skin/theme/index'
import ZwxVerifyCode from './components/other/verify/code/index'
import QrCode from './components/other/qr/code/index'

const COMPONENT_OTHER = [ZwxScrollbarX, ZwxScrollbarY, SkinTheme, ZwxVerifyCode, QrCode]

import ZwxSelectArea from './components/widgets/area/index'
import IndustrySelect from './components/widgets/industry/index'
const COMPONENT_WIDGET = [ZwxSelectArea,IndustrySelect]

const COMPONENT = []
    .concat(COMPONENT_LAYOUT)
    .concat(COMPONENT_DATA_INPUT)
    .concat(COMPONENT_DATA_DISPLAY)
    .concat(COMPONENT_FEEDBACK)
    .concat(COMPONENT_NAVIGATION)
    .concat(COMPONENT_OTHER)
    .concat(COMPONENT_WIDGET)


import System from './utils/system'
import Validate from './utils/validate'
import CommonTools from './utils/common'
import ZwxBase from './utils/base'
import ZwxCookie from './utils/cookie'
import ZwxLocalStorage from './utils/local-storage'
import ZwxJsStore from './utils/jsstore'
import ZwxSm from './utils/sm'
import ZwxSkin from './utils/skin'


export {System, Validate, CommonTools, ZwxBase, ZwxCookie, ZwxLocalStorage, ZwxJsStore, ZwxSm, ZwxSkin}

const install = function (Vue) {
    if (install.installed) return
    install.installed = true
    COMPONENT.map(component => {
        Vue.component(component.name, component)
    })
    Vue.prototype.$system = System
    Vue.prototype.$validate = Validate
    Vue.prototype.$CommonTools = CommonTools
    Vue.prototype.$zwxBases = ZwxBase
    Vue.prototype.$zwxCookie = ZwxCookie
    Vue.prototype.$zwxLocalStorage = ZwxLocalStorage
    Vue.prototype.$zwxJsStore = ZwxJsStore
    Vue.prototype.$zwxSm = ZwxSm
    Vue.prototype.$zwxSkin = ZwxSkin
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    install,
    ...COMPONENT,
}
